import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { getDeveloperRatings } from '../../selectors';
import { Ratings as RatingsComponent } from '../../components/Ratings';
import { Rating } from '../Rating';

export function Ratings() {
  const developerRatings = useSelector(getDeveloperRatings);
  const ratings = React.useMemo(
    () => developerRatings.map(rating => <Rating key={rating.id} ratingId={rating.id} />),
    [developerRatings],
  );

  if (!ratings.length) {
    return null;
  }

  return <RatingsComponent title={<ArticleHeading1>Рейтинги</ArticleHeading1>} ratings={ratings} />;
}
